import { PersonAdd, Settings, Logout } from '@mui/icons-material';
import { Menu, MenuItem, Avatar, Divider, ListItemIcon, Typography } from '@mui/material';
import React from 'react';
import ViewTimelineOutlinedIcon from '@mui/icons-material/ViewTimelineOutlined';

interface IProps {
  open: boolean;
  handleClose: (event, type, item: any, context?: any) => void;
  item: any;
  type: string;
  submenus: any[];
  context: any;
  anchorEl: null | HTMLElement;
}
const ActionBarMenu = ({ anchorEl, open, handleClose, item, type, submenus, context }: IProps) => {
  return (
    <div>
      {anchorEl && (
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={(event) => handleClose(event, null, item, context)}
          onClick={(event) => handleClose(event, null, item, context)}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              ml: 1,
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: 0.5,
                mr: 1,
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          disableAutoFocusItem
        >
          {submenus.map((m) => {
            return (
              <MenuItem onClick={(event) => handleClose(event, m.type, item, context)} key={m.type} className={m.className}>
                <div style={{ display: 'flex' }} className={m.className}>
                  {m.component !== 'Timeline' && (
                    <i
                      aria-hidden="true"
                      style={{ marginRight: m.type === 'downloadAsset' ? 13 : 12 }}
                      title={m.title}
                      key={m.type}
                      className={`${m.iconClass} ${m.type}`}
                    >
                      {m.iconName}
                    </i>
                  )}
                  {m.component === 'Timeline' && (
                    <span title={m.title} style={{ paddingRight: '10px', height: '21px' }}>
                      <ViewTimelineOutlinedIcon sx={{ fontSize: '23px' }} className={m.iconClass} />
                    </span>
                  )}
                  <Typography> {m.title}</Typography>
                </div>
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </div>
  );
};

export default ActionBarMenu;
